module.exports = __webpack_public_path__ + "static/img/cup.8f14b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/answer-share/cup.png
// module id = 829
// module chunks = 9